import { render, staticRenderFns } from "./AdvProductCard.vue?vue&type=template&id=067a8934"
import script from "./AdvProductCard.vue?vue&type=script&lang=js"
export * from "./AdvProductCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports